import { c as _c } from "react/compiler-runtime";
import React from "react";
interface EmbeddedEntryWrapperProps {
  classArray?: string[];
  extraClasses?: string;
  childComponent: React.ReactNode;
}
export const embeddedEntryDefaultClasses = `mb-8 md:mb-8 lg:mb-8 mx-auto`;
export const EmbeddedEntryWrapper = props => {
  const $ = _c(5);
  const {
    classArray,
    extraClasses
  } = props;
  let t0;
  if ($[0] !== classArray) {
    t0 = classArray && classArray.length > 0 ? classArray.join(" ") : embeddedEntryDefaultClasses;
    $[0] = classArray;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const classString = t0;
  const classNameFinal = `${classString} ${extraClasses}`;
  const t1 = props?.childComponent;
  let t2;
  if ($[2] !== classNameFinal || $[3] !== t1) {
    t2 = <div className={classNameFinal}>{t1}</div>;
    $[2] = classNameFinal;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};